import { render } from "./APICallsChart.vue?vue&type=template&id=450e23f4&scoped=true"
import script from "./APICallsChart.vue?vue&type=script&lang=js"
export * from "./APICallsChart.vue?vue&type=script&lang=js"

import "./APICallsChart.vue?vue&type=style&index=0&id=450e23f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450e23f4"]])

export default __exports__